import { proxy, transfer, wrap } from 'comlink';
import { createWorker } from '../../utils/workerUtils';
export class AbstractVideoEngine {
    worker;
    workerProxy;
    async init(optimalDelayCallback, encodedVideoOutputTrackAddedCallback) {
        console.log(`${this.LOG_PREFIX} init called`);
        await this.initializeWorker(optimalDelayCallback, encodedVideoOutputTrackAddedCallback);
        console.log(`${this.LOG_PREFIX} init completed`);
    }
    async destroy() {
        console.log(`${this.LOG_PREFIX} destroy called`);
        await this.onDestroy();
        //if (this.worker) {
        //    this.worker.terminate();
        //}
        this.worker = undefined;
        this.workerProxy = undefined;
        console.log(`${this.LOG_PREFIX} destroy completed`);
    }
    /**
     * Hook for subclasses to perform cleanup before the worker is destroyed.
     * Override this method to clean up subclass-specific resources.
     */
    async onDestroy() {
        // Default implementation does nothing
    }
    async setCanvas(canvas) {
        console.log(`${this.LOG_PREFIX} setCanvas called`, { canvas });
        const offscreenCanvas = canvas.transferControlToOffscreen();
        await this.workerProxy?.setCanvas(transfer(offscreenCanvas, [offscreenCanvas]));
        console.log(`${this.LOG_PREFIX} setCanvas completed`, { canvas });
    }
    async setReferenceTimes(trackIds, presentationTimeMicros, realTimeMillis) {
        await this.workerProxy?.setReferenceTimes(trackIds, presentationTimeMicros, realTimeMillis);
    }
    async feedEncodedVideoFrame(frame) {
        if (frame.done) {
            console.log(`${this.LOG_PREFIX} feedEncodedVideoFrame done`, {
                frame,
            });
        }
        await this.workerProxy?.feedEncodedVideoFrame(frame);
    }
    async handleLeave(userSessionId) {
        console.log(`${this.LOG_PREFIX} handleLeave called`, { userSessionId });
        await this.workerProxy?.handleLeave(userSessionId);
    }
    async initializeWorker(optimalDelayCallback, encodedVideoOutputTrackAddedCallback) {
        console.log(`${this.LOG_PREFIX} initializeWorker started`);
        this.worker = this.createWorker();
        this.workerProxy = wrap(this.worker);
        await this.workerProxy.init(proxy(optimalDelayCallback), proxy(encodedVideoOutputTrackAddedCallback));
        console.log(`${this.LOG_PREFIX} initializeWorker completed`);
    }
    /**
     * Helper method to create a worker using webpack's URL constructor.
     * Use this in subclasses when BUILD_TRANSFORMS_FILENAMES is true.
     */
    static createWorkerWithUrl(url) {
        return new Worker(url, { type: 'module' });
    }
    /**
     * Helper method to create a worker using the createWorker utility.
     * Use this in subclasses when BUILD_TRANSFORMS_FILENAMES is false.
     */
    createWorkerWithUtil(workerFileName) {
        // Use .ts extension for Vite dev server, .js for production
        const ext = import.meta.env.DEV ? '.ts' : '.js';
        return createWorker(`./${workerFileName}${ext}`, import.meta.url);
    }
}
